module.exports = __webpack_public_path__ + "static/media/local_grocery_store_white_24dp.94e23382.svg";